export const getColorVar = (color: string) => `var(--c-${color})`;

export const getColor = (color?: string, opacity?: number) => {
  if (!color) return null;
  const appVar = getColorVar(color);
  return opacity && opacity !== 1 ? `rgba(${appVar}, ${opacity})` : `rgb(${appVar})`;
}
